import { BrowserRouter } from 'react-router-dom';

import Router from './Router';

import './default.css';
import Header from './Components/Header';

export default function App() {
	return(
		// (user.indexOf("iPhone") > -1 || user.indexOf("Android") > -1) ?
		<div className='App'>
			<BrowserRouter>
				<Header />
				<Router />
			</BrowserRouter>
		</div>
		// :<div>모바일 웹으로 접속해주세요!</div>
	);
}